/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Building_AreaInputs */

const cs_form_building_area = /** @type {(inputs: Form_Building_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zastavěná plocha (m²)`)
};

const en_form_building_area = /** @type {(inputs: Form_Building_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building area (m²)`)
};

/**
* | output |
* | --- |
* | "Building area (m²)" |
*
* @param {Form_Building_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_building_area = /** @type {((inputs?: Form_Building_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Building_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_building_area(inputs)
	return cs_form_building_area(inputs)
});